import { useLocation, useNavigate } from "react-router-dom";

function Summary() {
  const navigate = useNavigate();
  const location = useLocation();

  const { score = 0, total = 1 } = location.state || {};

  const percentage = Math.round((score / (total * 10)) * 100);

  let feedback = "";
  let strength = "";
  let weakness = "";

  if (percentage > 75) {
    feedback = "🔥 Excellent performance!";
    strength = "Strong concepts & clarity";
    weakness = "Minor improvements needed";
  } else if (percentage > 50) {
    feedback = "👍 Good attempt!";
    strength = "Basic understanding is good";
    weakness = "Need more depth & examples";
  } else {
    feedback = "⚠️ Needs improvement";
    strength = "Good effort";
    weakness = "Concept clarity & explanation";
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1>📊 Interview Summary</h1>

        <h2>Score: {score} ⭐</h2>
        <h3>Performance: {percentage}%</h3>

        <p style={styles.feedback}>{feedback}</p>

        <div style={styles.box}>
          <p>✅ Strength: {strength}</p>
          <p>❌ Weakness: {weakness}</p>
        </div>

        <button
          onClick={() => navigate("/dashboard")}
          style={styles.btn}
        >
          Go to Dashboard 🚀
        </button>
      </div>
    </div>
  );
}

// 🔥 STYLES
const styles = {
  container: {
    height: "100vh",
    background: "#1e1e2f",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
  },

  card: {
    background: "rgba(255,255,255,0.1)",
    padding: "30px",
    borderRadius: "15px",
    width: "400px",
    textAlign: "center",
    backdropFilter: "blur(10px)",
    boxShadow: "0 5px 20px rgba(0,0,0,0.3)",
  },

  feedback: {
    fontSize: "18px",
    margin: "20px 0",
  },

  box: {
    background: "rgba(255,255,255,0.05)",
    padding: "15px",
    borderRadius: "10px",
    marginBottom: "20px",
  },

  btn: {
    padding: "12px",
    width: "100%",
    background: "linear-gradient(135deg, #00c6ff, #0072ff)",
    border: "none",
    borderRadius: "8px",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default Summary;